import {all, call, fork, put, select, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import {get, post} from 'bukku/shared/ApiService';
import {Helper} from "./helper";
import {t} from "@lingui/macro";

// Read store
export function* readStoreRequest() {
    yield takeEvery(actions.STORE_READ_STORE_REQUEST, function* (payload, context) {
        try {
            const response = yield call(get, '/store', null, context);
            const data = yield response.data;

            // const data = yield getDummyStore()

            yield put({
                type: actions.STORE_READ_STORE_SUCCESS,
                store: {
                    friendlyName: data.store.friendly_name,
                    logoUrl: data.store.logo_url,
                    email: data.store.email,
                    phoneNo: data.store.phone_no,
                    url: data.store.url,
                    billingAddress: data.store.billing_address,
                    addressText: data.store.address_text,
                    street: data.store.street,
                    city: data.store.city,
                    state: data.store.state,
                    postcode: data.store.postcode,
                    countryCode: data.store.country_code,
                    currencySymbol: data.store.currency_symbol,
                    bannerUrl: data.store.banner_url,
                    hasPaymentGateway: data.store.store_online_payment, // boolean - has payment gateway
                    paymentGatewayProvider: data.store.payment_gateway_provider, // 'stripe', 'payex', etc.
                    minimumSpend: data.store.minimum_spend, // used for stripe
                },
                categories: data.categories,
            });
        }
        catch (error) {
            yield put({
                type: actions.STORE_READ_STORE_FAILURE,
                error,
            });
        }
    });
}
export function* readStoreSuccess() {
    yield takeEvery(actions.STORE_READ_STORE_SUCCESS, () => {});
}
export function* readStoreFailure() {
    yield takeEvery(actions.STORE_READ_STORE_FAILURE, () => {});
}

// Read categories
export function* readCategoriesRequest() {
    yield takeEvery(actions.STORE_READ_CATEGORIES_REQUEST, function* (payload, context) {
        try {
            const response = yield call(get, '/store/categories', null, context);
            const data = yield response.data;

            yield put({
                type: actions.STORE_READ_CATEGORIES_SUCCESS,
                categories: data.categories,
            });
        }
        catch (error) {
            yield put({
                type: actions.STORE_READ_CATEGORIES_FAILURE,
                error,
            });
        }
    });
}
export function* readCategoriesSuccess() {
    yield takeEvery(actions.STORE_READ_CATEGORIES_SUCCESS, () => {});
}
export function* readCategoriesFailure() {
    yield takeEvery(actions.STORE_READ_CATEGORIES_FAILURE, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read categories
export function* readFeaturedRequest() {
    yield takeEvery(actions.STORE_READ_FEATURED_REQUEST, function* (payload, context) {
        try {
            const response = yield call(get, '/store/featured', null, context);
            const data = yield response.data;

            const { Store } = yield select();
            let newProductData = Store.productData;
            data.categories.forEach(category => {
                newProductData = Helper.updateProductData(category.items, Store.productData);
            });

            yield put({
                type: actions.STORE_READ_FEATURED_SUCCESS,
                featured: {
                    categories: data.categories.map(category => ({
                        id: category.id,
                        name: category.name,
                        items: category.items.map(product => ({
                            id: product.id,
                            sku: product.sku,
                            name: product.name,
                            description: product.description,
                            salePrice: product.unit_price,
                            unitLabel: product.unit_label,
                            pictureUrl: product.picture_url,
                            thumbnailUrl: product.thumbnail_url,
                            isAvailable: product.is_available,
                        })),
                    })),
                },
                productData: newProductData,
            });
        }
        catch (error) {
            yield put({
                type: actions.STORE_READ_FEATURED_FAILURE,
                error,
            });
        }
    });
}
export function* readFeaturedSuccess() {
    yield takeEvery(actions.STORE_READ_FEATURED_SUCCESS, () => {});
}
export function* readFeaturedFailure() {
    yield takeEvery(actions.STORE_READ_FEATURED_FAILURE, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read items in category
export function* readProductsInCategoryRequest() {
    yield takeEvery(actions.STORE_READ_PRODUCTS_IN_CATEGORY_REQUEST, function* ({request}, context) {
        try {
            const response = yield call(get, '/store/products', request, context);
            const data = yield response.data;

            const { Store } = yield select();
            const newProductData = Helper.updateProductData(data.products, Store.productData);

            yield put({
                type: actions.STORE_READ_PRODUCTS_IN_CATEGORY_SUCCESS,
                products: data.products.map(product => ({
                    id: product.id,
                    sku: product.sku,
                    name: product.name,
                    description: product.description,
                    salePrice: product.unit_price,
                    unitLabel: product.unit_label,
                    pictureUrl: product.picture_url,
                    thumbnailUrl: product.thumbnail_url,
                    isAvailable: product.is_available,
                })),
                pagination: data.paging,
                productData: newProductData,
            });
        }
        catch (error) {
            yield put({
                type: actions.STORE_READ_PRODUCTS_IN_CATEGORY_FAILURE,
                error,
            });
        }
    });
}
export function* readProductsInCategorySuccess() {
    yield takeEvery(actions.STORE_READ_PRODUCTS_IN_CATEGORY_SUCCESS, () => {});
}
export function* readProductsInCategoryFailure() {
    yield takeEvery(actions.STORE_READ_PRODUCTS_IN_CATEGORY_FAILURE, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read product details
export function* readProductDetailsRequest() {
    yield takeEvery(actions.STORE_READ_PRODUCT_DETAILS_REQUEST, function* ({ productId }, context) {
        try {
            const response = yield call(get, `/store/products/${productId}`, null, context);
            const data = yield response.data;

            yield put({
                type: actions.STORE_READ_PRODUCT_DETAILS_SUCCESS,
                product: {
                    id: data.id,
                    sku: data.sku,
                    name: data.name,
                    salePrice: data.unit_price,
                    unitLabel: data.unit_label,
                    pictureUrl: data.picture_url,
                    isAvailable: data.is_available,
                    description: data.description,
                },
            });
        }
        catch (error) {
            yield put({
                type: actions.STORE_READ_PRODUCT_DETAILS_FAILURE,
                error,
            });
        }
    });
}
export function* readProductDetailsSuccess() {
    yield takeEvery(actions.STORE_READ_PRODUCT_DETAILS_SUCCESS, () => {});
}
export function* readProductDetailsFailure() {
    yield takeEvery(actions.STORE_READ_PRODUCT_DETAILS_FAILURE, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Place Order
export function* placeOrderRequest() {
    yield takeEvery(actions.STORE_PLACE_ORDER_REQUEST, function* (payload, context) {
        try {
            const { Store } = yield select();

            if (Store.shoppingCart.length === 0)
                return new Error(t`Shopping Cart is empty`);

            const request = {
                customer_name: Store.customerOrder.customerName,
                customer_mobile: Store.customerOrder.customerMobile,
                customer_email: Store.customerOrder.customerEmail,
                delivery_street: Store.customerOrder.deliveryStreet,
                delivery_city: Store.customerOrder.deliveryCity,
                delivery_state: Store.customerOrder.deliveryState,
                delivery_postcode: Store.customerOrder.deliveryPostcode,
                delivery_country_code: Store.customerOrder.deliveryCountryCode,
                instruction: Store.customerOrder.instruction,
                secret: Store.shoppingCartSecret,
                items: Store.shoppingCart.map(item => ({
                    product_id: item.productId,
                    quantity: item.qty,
                    instruction: item.instruction,
                    amount: item.amount,
                })),
            };

            const response = yield call(post, '/store/orders', request, context);
            const data = yield response.data;

            yield put({
                type: actions.STORE_PLACE_ORDER_SUCCESS,
                paymentData: data,
            });
        }
        catch (error) {
            yield put({
                type: actions.STORE_PLACE_ORDER_FAILURE,
                error,
            });
        }
        return null;
    });
}
export function* placeOrderSuccess() {
    yield takeEvery(actions.STORE_PLACE_ORDER_SUCCESS, () => {});
}
export function* placeOrderFailure() {
    yield takeEvery(actions.STORE_PLACE_ORDER_FAILURE, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Get Order Details
export function* getOrderDetailsRequest() {
    yield takeEvery(actions.STORE_GET_ORDER_DETAILS_REQUEST, function* ({key}, context) {
        try {
            const response = yield call(get, `/store/orders/${key}`, null, context);
            const data = yield response.data;

            yield put({
                type: actions.STORE_GET_ORDER_DETAILS_SUCCESS,
                order: {
                    ...data.order,
                    ...{payment_instruction: data.payment_instructions},
                },
            });

            const { Store } = yield select();
            const toClearCart = Store.shoppingCartSecret === data.order.secret;
            // const toClearCart = false
            if (toClearCart) {
                yield put({
                    type: actions.STORE_CLEAR_CART,
                });
            }
        }
        catch (error) {
            yield put({
                type: actions.STORE_GET_ORDER_DETAILS_FAILURE,
                error,
            });
        }
    });
}
export function* getOrderDetailsSuccess() {
    yield takeEvery(actions.STORE_GET_ORDER_DETAILS_SUCCESS, () => {});
}
export function* getOrderDetailsFailure() {
    yield takeEvery(actions.STORE_GET_ORDER_DETAILS_FAILURE, () => {});
}

// Recalculate
export function* recalculateRequest() {
    yield takeEvery([
        actions.STORE_ADD_ITEM_IN_CART,
        actions.STORE_ADD_QTY_IN_CART,
        actions.STORE_SUBTRACT_QTY_IN_CART,
        actions.STORE_SET_QTY_IN_CART,
        actions.STORE_SET_INSTRUCTION_IN_CART,
        actions.STORE_REMOVE_ITEM_IN_CART,
        actions.STORE_CLEAR_CART,
        actions.STORE_READ_STORE_SUCCESS,
        actions.STORE_RECALCULATE_REQUEST,
    ],
    function* ({ overwrite, type }) {
        try {
            const { Store } = yield select();

            // Find out what productId to request price for
            const getProductIdsToRequest = yield Helper.getProductIdsToRequest(overwrite || false);

            // Fetch price data & update "productData"
            if (getProductIdsToRequest.length) {
                yield put({
                    type: actions.STORE_READ_PRODUCT_DATA_REQUEST,
                    productIds: getProductIdsToRequest,
                });
            }
            else {
                const output = Helper.calculateAmounts(Store.shoppingCart, Store.productData);
                const [newShoppingCart, newTotals] = output;
                let productsWithPriceChanges = output[2];

                // do not prompt price change if unit_price changes due to qty change from price level
                switch (type) {
                    case actions.STORE_ADD_ITEM_IN_CART:
                    case actions.STORE_ADD_QTY_IN_CART:
                    case actions.STORE_SUBTRACT_QTY_IN_CART:
                    case actions.STORE_SET_QTY_IN_CART:
                    case actions.STORE_REMOVE_ITEM_IN_CART:
                        productsWithPriceChanges = [];
                        break;
                    default:
                        break;
                }

                yield put({
                    type: actions.STORE_RECALCULATE_SUCCESS,
                    shoppingCart: newShoppingCart,
                    totals: newTotals,
                    productsWithPriceChanges,
                    productsNotAvailable: [],
                    productsOutOfStock: [],
                });
            }
        }
        catch {
            // empty
        }
    });
}
export function* recalculateFailure() {
    yield takeEvery(actions.STORE_RECALCULATE_FAILURE, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read Pricing
export function* readProductDataRequest() {
    yield takeEvery(actions.STORE_READ_PRODUCT_DATA_REQUEST, function* ({productIds}, context) {
        try {
            const response = yield call(get, '/store/products', {product_ids: productIds}, context);
            const data = yield response.data;

            // Update Prices
            const { Store } = yield select();
            const newProductData = Helper.updateProductData(data.products, Store.productData);
            yield put({
                type: actions.STORE_READ_PRODUCT_DATA_SUCCESS,
                productData: newProductData,
            });

            // Recalculates
            const [
                newShoppingCart,
                newTotals,
                productsWithPriceChanges,
            ] = Helper.calculateAmounts(Store.shoppingCart, newProductData);
            const [
                newShoppingCart2,
                productsNotAvailable,
                productsOutOfStock,
            ] = Helper.checkProductNotAvailable(productIds, data.products, newShoppingCart);

            yield put({
                type: actions.STORE_RECALCULATE_SUCCESS,
                shoppingCart: newShoppingCart2,
                totals: newTotals,
                productsWithPriceChanges,
                productsNotAvailable,
                productsOutOfStock,
            });
        }
        catch (error) {
            yield put({
                type: actions.STORE_READ_PRODUCT_DATA_FAILURE,
                error,
            });
        }
    });
}
export function* readProductDataSuccess() {
    yield takeEvery(actions.STORE_READ_PRODUCT_DATA_SUCCESS, () => {});
}
export function* readProductDataFailure() {
    yield takeEvery(actions.STORE_READ_PRODUCT_DATA_FAILURE, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readStoreRequest),
        fork(readStoreSuccess),
        fork(readStoreFailure),
        fork(readCategoriesRequest),
        fork(readCategoriesSuccess),
        fork(readCategoriesFailure),
        fork(readFeaturedRequest),
        fork(readFeaturedSuccess),
        fork(readFeaturedFailure),
        fork(readProductsInCategoryRequest),
        fork(readProductsInCategorySuccess),
        fork(readProductsInCategoryFailure),
        fork(readProductDetailsRequest),
        fork(readProductDetailsSuccess),
        fork(readProductDetailsFailure),
        fork(getOrderDetailsRequest),
        fork(getOrderDetailsSuccess),
        fork(getOrderDetailsFailure),
        fork(placeOrderRequest),
        fork(placeOrderSuccess),
        fork(placeOrderFailure),
        fork(recalculateRequest),
        fork(recalculateFailure),
        fork(readProductDataRequest),
        fork(readProductDataSuccess),
        fork(readProductDataFailure),
    ]);
}
